import { render, staticRenderFns } from "./voyage.vue?vue&type=template&id=5ddfd948&scoped=true"
import script from "./voyage.vue?vue&type=script&lang=js"
export * from "./voyage.vue?vue&type=script&lang=js"
import style0 from "./voyage.vue?vue&type=style&index=0&id=5ddfd948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfd948",
  null
  
)

export default component.exports